export const REQUIRED_FIELD_MESSAGE = 'Este campo é obrigatório.'
